import { ChangeDetectionStrategy, Component, Inject, signal, ViewChild, WritableSignal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import { IsLoading } from '../../decorators';
import { CreateEditBuyerPersonaGroupComponent, BuyerPersonaGroupData } from './create-edit-buyer-persona-group.component';
import { CREATE_EDIT_BUYER_PERSONA_LOADING_TAG, CreateEditBuyerPersonaGroupService } from './services/create-edit-buyer-persona-group.service';
import { SiModalModule } from '../../components';
import { AsyncPipe } from '@angular/common';

@UntilDestroy()
@Component({
  selector: 'app-create-edit-buyer-persona-group-dialog',
  template: `
    <app-si-dialog
      [header]="(!!data?.id ? 'Edit' : 'New') + ' Buyer Persona Group'"
      modalBodyClasses="flex flex-col overflow-hidden"
      [isLoading]="isLoading$ | async"
      [saveButtonDisabled]="!isValid() || (isLoading$ | async)"
      (save)="onSave()"
    >
      <ng-template appDialogBody>
        <app-create-edit-buyer-persona-group
          class="flex flex-col h-full w-full"
          #formComponent
          [data]="data"
          (isValidChange)="onValidityChange($event)"
        ></app-create-edit-buyer-persona-group>
      </ng-template>
    </app-si-dialog>
  `,
  imports: [
    SiModalModule,
    CreateEditBuyerPersonaGroupComponent,
    AsyncPipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [CreateEditBuyerPersonaGroupService],
})
export class CreateEditBuyerPersonaGroupDialogComponent {
  @IsLoading(CREATE_EDIT_BUYER_PERSONA_LOADING_TAG) readonly isLoading$: Observable<boolean>;
  @ViewChild('formComponent') formComponent: CreateEditBuyerPersonaGroupComponent;

  isValid: WritableSignal<boolean> = signal<boolean>(false);

  constructor(
    private readonly matDialogRef: MatDialogRef<CreateEditBuyerPersonaGroupDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data: BuyerPersonaGroupData,
  ) {
  }

  onValidityChange(isValid: boolean): void {
    this.isValid.set(isValid);
  }

  onSave(): void {
    if (!this.isValid()) return;

    this.formComponent.save()
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        this.matDialogRef.close(true);
      });
  }
}
